import { useCallback, useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { IDeal, IDealPayload } from '@/creditflowresearch/domain/vo/ArticlesAndStats/Articles/IDeal';
import { AlertManager } from '@creditflowresearch/uilib/Alert';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import CreditFlowResearchRepository from '@/creditflowresearch/infrastructure/repository/CreditFlowResearchRepository';

export const useArticleDealsList = () => {
  const [collection, setCollection] = useState<IDeal[]>([]);
  const [isFetching, setIsFetching] = useState(false);
  const container = getContainer();

  const getDealsList = useCallback(async (payload: IDealPayload) => {
    setIsFetching(true);

    try {
      const creditFlowResearchRepository = container.get<CreditFlowResearchRepository>(CreditFlowResearchRepository);
      const collectionDeals = await creditFlowResearchRepository.getDealsList(payload);

      setCollection(collectionDeals.collection);

      return collectionDeals.collection;
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
      return [];
    } finally {
      setIsFetching(false);
    }
  }, [container]);

  return {
    isFetching,
    collection,
    getDealsList,
  };
};
